import React from "react"
import Layout from "../hocs/layout/Layout";
import { Card, Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { connect } from "react-redux";
import { RootState } from "../../store";
import { Helmet } from "react-helmet-async";
import { Table, Truck } from "react-bootstrap-icons";

interface NavItem {
  name: string;
  href: string;
  title: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  descripcion: string;
  disabled: boolean;
}
const pageVariants = {
  // initial: { opacity: 0, scale: 0.98 },
  // in: { opacity: 1, scale: 1 },
  initial: { x: -100, }, // Comienza con transparencia y desplazamiento desde la izquierda
  in: { x: 0, }, // Llega a opacidad completa y posición natural
};

const pageTransition = {
  type: "tween",
  easeIn: "anticipate",
  duration: 0.3,
  // delay: 0.05,
};

interface Props {
  isDarkMode: boolean;
}

const navigation: NavItem[] = [

  { descripcion: 'Envíe sus bienes a otros establecimientos.', name: 'registrarTraspasos', title: 'Registrar Traspasos', href: '/Traspasos/RegistrarTraspasos/', icon: Truck, disabled: false },
  { descripcion: 'Confirme la recepción de los bienes en su establecimiento.', name: 'listarTraspasos', title: 'Listado de Traspasos', href: '/Traspasos/ListadoTraspasos/', icon: Table, disabled: false },
];

const Traspasos: React.FC<Props> = ({ isDarkMode }) => {
  return (
    <Layout>
      <Helmet>
        <title>Traspasos</title>
      </Helmet>

      <AnimatePresence mode="wait">
        <motion.div key={location.pathname} initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition}>
          <div className="container mt-2">
            <Row className="g-2">
              {navigation.map((item) => (

                < Col key={item.name} lg={4} md={6} sm={12} >

                  <NavLink
                    to={item.disabled ? "#" : item.href}
                    className={`text-white btn-sm mt-auto text-decoration-none `}
                  >

                    <div className={`${item.disabled ? "opacity-50 pointer-events-none cursor-not-allowed" : ""} ${isDarkMode ? "bg-color-dark" : "bg-color"} p-4 border-0 shadow-lg rounded h-100 d-flex flex-column card-hover`}>
                      <div className="mb-3">
                        <item.icon className="me-3 mt-5 fs-2 flex-shrink-0" aria-hidden="true" />
                      </div>

                      <Card.Title className="fw-bold">{item.title}</Card.Title>

                      <Card.Text className="fw-light flex-grow-1 mb-2">
                        {item.descripcion}
                      </Card.Text>
                      {item.disabled && <span className="badge bg-warning text-white fw-bold">En Mantención</span>}
                    </div>

                  </NavLink>
                </Col>
              ))}
            </Row>
          </div>
        </motion.div>
      </AnimatePresence>
    </Layout >
  );
};

const mapStateToProps = (state: RootState) => ({
  isDarkMode: state.darkModeReducer.isDarkMode
});

export default connect(mapStateToProps, {
})(Traspasos);


